import type { AdminFlagUpdateParams, FlagUser } from 'services/api/fields';
import http from 'services/http';

export const adminFlagsQueryKeys = {
  index: () => ['adminFlags'] as const,
  show: (name: string) => ['adminFlags', name] as const,
};

export type FlagOptions = {
  name: string;
  title: string;
  globallyEnabled: boolean;
  category: 'client' | 'global' | null;
  groups: string[];
  clients: { id: string; name: string }[];
  // Missing until the api half of this change is live.
  users?: FlagUser[];
};

export async function adminIndexFlags() {
  return http.get<{ data: FlagOptions[] }>('admin/flags').then((res) => res.data.data);
}

export async function adminShowFlag(name: string) {
  return http.get<FlagOptions>(`admin/flags/${name}`).then((res) => res.data);
}

export async function adminUpdateFlag(name: string, params: AdminFlagUpdateParams) {
  return http.patch<FlagOptions>(`admin/flags/${name}`, params).then((res) => res.data);
}
